<template>
  <div class="home">
    <Welcome msg="Bienvenidos a Centro Medico Terrada"/>    
  </div>
</template>

<script>
// @ is an alias to /src
import Welcome from '@/components/Welcome.vue'

export default {
  name: 'home',
  components: {
    Welcome
  }
}
</script>

